// Equipe Sesi e CNPJ
export const LANDING_PAGE = "/"
export const CREW_LOGIN = "/login-equipe-sesi"
export const CREW_PAGE = "/equipe-sesi"
export const HOME_LOGGED = "/home"
export const VALIDATION = "/validacao"
export const SELECTEMAIL = "/selecemail"
export const RESETPASSWORD = "/alterar-senha"
export const FORGOTPASSWORD = "/esqueci-senha"
export const HISTORY = "/historico-adesao"
export const ENTERPRISEREGISTER = "/cadastro-empresa"
export const ADDADHERENSE = "/incluir-adesao"
export const ALLADHERENSE = "/incluir-adesao-geral"
export const ADHERENSEHISTORY = "/historico-adesoes"
export const CANCELPLANS = "/cancelamento-de-planos"
export const CANCELREQUEST = "/solicitacoes-de-cancelamento"
export const SELECTPLANMODIFICATION = "/alteracao-de-plano"
export const PLANCHANGEVALIDATION = "/validacao-de-alteracao-de-planos"
export const AGREEMENTHISTORY = "/historico-de-convenios"

// Pessoa
export const PREREGISTER = "/registro-pessoa"
export const MYCONTRACTS = "/meus-contratos"
export const TYPEREGISTER = "/tipos-registro"
export const PARTICULAR = "/registro-particular"
export const PFFORM = "/formulario-pessoa-fisica"
export const ATTINFOS = "/atualizacao-cadastral"
export const SELECTDEPENDENTS = "/seleciona-dependentes"
export const DOCUMENTS = "/documents"


